import { logger } from '@/utils/screenEventsLogger';

export async function enableKeepAliveMode() {
  await new Promise((resolve, reject) => {
    const successCallbackObject = (_successObject: any) => {
      logger.addLog('Enabled keep alive mode successful');
      resolve(true);
    };

    const failureCallbackObject = (cbObject: any) => {
      logger.addLog('Error Code [' + cbObject.errorCode + ']: ' + cbObject.errorText);
      reject();
    };

    // @ts-ignore: SCAP API
    var custom = new Custom();
    custom.Configuration.setKAM(successCallbackObject, failureCallbackObject, {
      keepAliveMode: true,
    });
  });
}

export async function tryGetWebOSVersion() {
  return new Promise((resolve, reject) => {
    const successCallbackObject = (successObject: any) => {
      resolve({ webOSVersion: successObject.webOSVersion });
    };

    const failureCallbackObject = (cbObject: any) => {
      logger.addLog('Failed to get WebOS version');
      logger.addLog('[' + cbObject.errorCode + '] ' + cbObject.errorText);
      resolve({ webOSVersion: null });
    };
    try {
      // @ts-ignore: SCAP API
      var custom = new Custom();
      custom.Signage.getwebOSVersion(successCallbackObject, failureCallbackObject);
    } catch (error) {
      logger.addLog('Error getting WebOS version: ' + error);
      resolve({ webOSVersion: null });
    }
  });
}
